export default __webpack_public_path__ + "static/media/news3.ceff4a6e.png";